/**
 * Unified Analytics Tracker
 * PostHog + Meta Pixel + Facebook SDK + Clarity
 * All IDs configured via .env variables
 */

// PostHog events
export const trackEvent = (eventName, properties = {}) => {
  // PostHog
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture(eventName, properties);
  }

  // Meta Pixel
  if (window.fbq) {
    window.fbq('trackCustom', eventName, properties);
  }
};

// Track page view
export const trackPageView = (pageName) => {
  trackEvent('page_view', { page: pageName });
  
  // Meta Pixel standard page view
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track user identification
export const identifyUser = (userId, traits = {}) => {
  if (window.posthog && typeof window.posthog.identify === 'function') {
    window.posthog.identify(userId, traits);
  }
};

// Standard conversion events
export const trackSignUp = (method = 'form') => {
  trackEvent('sign_up', { method });
  if (window.fbq) window.fbq('track', 'CompleteRegistration', { method });
};

export const trackStoryGenerated = (language, name) => {
  trackEvent('story_generated', { language, name });
  if (window.fbq) window.fbq('track', 'ViewContent', { content_name: 'story', language });
};

export const trackPaymentInitiated = (plan, amount) => {
  trackEvent('payment_initiated', { plan, amount });
  if (window.fbq) window.fbq('track', 'InitiateCheckout', { value: amount, currency: 'INR' });
};

export const trackPaymentCompleted = (plan, amount) => {
  trackEvent('payment_completed', { plan, amount });
  if (window.fbq) window.fbq('track', 'Purchase', { value: amount, currency: 'INR' });
};

export const trackLandingPageVisit = (source) => {
  trackEvent('landing_page_visit', { source, utm_source: new URLSearchParams(window.location.search).get('utm_source') || 'direct' });
};

export const trackAppDownload = (platform) => {
  trackEvent('app_download_click', { platform });
  if (window.fbq) window.fbq('track', 'Lead', { platform });
};
